wbApp.controller('HolidayCalendarsDetailCtrl', ['$scope', 'holidayCalendarSvc',
function ($scope, holidayCalendarSvc) {

    if (!$scope.model.days) {
        $scope.model.days = [];
    }

    $scope.modelOrig = angular.copy($scope.model);
    $scope.selectedYear = moment().year();

    $scope.detailIsUnchanged = function (data) {
        return angular.equals(data, $scope.modelOrig);
    };

    $scope.isSaving = false;

    $scope.onDeleteDay = function(selectedDay) {
        var index = $scope.model.days.indexOf(selectedDay);
        if (index !== -1) $scope.model.days.splice(index, 1);
    }

    $scope.onAddDay = function (selectedDay) {
        if (!!selectedDay && moment(selectedDay).isValid()) {
            var alreadyExist = _.find($scope.model.days, function (d) {
                return moment(d).isSame(selectedDay);
            });

            if (!alreadyExist) {
                $scope.model.days.push(selectedDay);

                $scope.model.days.sort(function (a, b) {
                    if (moment(a).isBefore(b)) {
                        return -1;
                    }

                    if (moment(a).isAfter(b)) {
                        return 1;
                    }

                    return 0;
                });
            }
        }
    }

    $scope.onAddBankHoliday = function(year) {
        var bankHoliday = holidayCalendarSvc.getBankHoliday('CZK', year);
        bankHoliday.$promise.then(function (data) {
            _.forEach(data.days, function (day) {
                $scope.onAddDay(day);
            });
        });
    }

    $scope.onDetailSave = function (model) {

        $scope.isSaving = true;

        var promise;
        if (!model.id) {
            promise = holidayCalendarSvc.insert(model).$promise;
        } else {
            promise = holidayCalendarSvc.update(model).$promise;
        }

        function success(data) {
            $scope.isSaving = false;
            if (!!$scope.onDataSave) {
                $scope.onDataSave(data);
            }
            $scope.$hide();
        }

        function error(data) {
            $scope.isSaving = false;
            $scope.detailError = data;
        }

        promise.then(success, error);
    }
}]);
